// Entry point for the build script in your package.json

// Libraries
import './lib/rails';
import './lib/jquery';
import './lib/bootstrap';
import './lib/toastr';
import './lib/turbo';

// App modules
import './cable';
import './application/init_tooltip';

// Forms
import './auto_submit_form';

// Users
import './users/profile';

// STIMULUS
import './controllers';

if (!Rails.started) {
  Rails.start();
}
